import styled from 'styled-components';
import { rem } from 'polished';

const FontFamily = ({ theme: { $fontFamily } }) => `${$fontFamily}`;
const baseFont = `12px`;
const S = {};

const FwRegular = ({theme:{$fwRegular}}) => `${$fwRegular}`;
const FwSemibold = ({theme:{$fwSemibold}}) => `${$fwSemibold}`;

const HeaderTextColor = ({theme: {$headerTextColor}}) => `${$headerTextColor}`;
const MethodBorderColor = ({theme: {$methodBorderColor}}) => `${$methodBorderColor}`;
const MethodBackgroundColor = ({theme: {$methodBackgroundColor}}) => `${$methodBackgroundColor}`;
const MethodTextColor = ({theme: {$methodTextColor}}) => `${$methodTextColor}`;

S.Title = styled.h2`
  margin: 0;
  color: ${HeaderTextColor};
  font-family: 'Source Sans Pro', ${FontFamily};
  font-weight: ${FwRegular};
  font-size: ${rem('26px')};
  line-height: 100%;
  text-align: center;
`;

S.ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: ${rem('16px')};
`;

S.MethodButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between; 
  padding: ${rem('20px')} ${rem('24px')} ${rem('22px')} ${rem('24px')};
  border-radius: 3px;
  border: 1px solid ${MethodBorderColor};
  background-color: ${MethodBackgroundColor};
  cursor: pointer;
  transition: border-color 0.2s;
`;

S.MethodContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  flex: 1;
`;

S.HeaderRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${rem('8px')};
`;

S.MethodTitle = styled.div`
  font-family: 'Source Sans Pro', ${FontFamily};
  font-size: ${rem('16px')};
  font-weight: ${FwSemibold};
  color: ${MethodTextColor};
  margin-left: ${rem('12px')};
`;

S.MethodDescription = styled.div`
  font-family: 'Source Sans Pro', ${FontFamily};
  font-size: ${rem('14px')};
  font-weight: 400;
  color: ${MethodTextColor};
`;

S.IconBank = styled.div`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;

S.IconForm = styled.div`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;

S.ArrowRight = styled.div`
  width: 10px;
  height: 10px;
  border-top: 2px solid ${MethodTextColor};
  border-right: 2px solid ${MethodTextColor};
  transform: rotate(45deg);
  flex-shrink: 0;
`;

export default S;